import React from 'react';
import Breadcrumb from '../../../components/section/Breadcrumb';
import FooterSection from '../section/FooterSection';
import HeaderSection from '../section/HeaderSection';
import SubscribeSection from '../section/SubscribeSection';
import VendorDetailSection from '../section/VendorDetailSection';

function VendorDetailPage() {
    return (
        <>
            <HeaderSection />
            <Breadcrumb title="Vendor Detail" />
            <VendorDetailSection />
            <SubscribeSection />
            <FooterSection />
        </>
    );
}

export default VendorDetailPage;
